import { AdsHandlerActionTypes } from './adsHandler.types';

export const initialState = {
  pages: {
    list: [],
    loading: false,
    error: null,
    status: null,
  },
  drafts: {
    data: null,
    loading: false,
    error: null,
    status: null,
  },
  unlinkAccount: {
    loading: false,
    unlinked: false,
  },
  insights: {
    data: null,
    loading: false,
    status: null,
  },
};

const adsHandlerReducer = (state = initialState, action) => {
  switch (action.type) {
    case AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_SUCCESS: {
      return {
        ...state,
        pages: {
          list: [],
          loading: false,
          error: null,
          status: null,
        },
        drafts: {
          data: null,
          loading: false,
          error: null,
          status: null,
        },
        unlinkAccount: {
          ...state.unlinkAccount,
          unlinked: true,
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_LOADING: {
      return {
        ...state,
        unlinkAccount: {
          ...state.unlinkAccount,
          loading: action.payload,
          unlinked: false,
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_REQUEST: {
      return {
        ...state,
        unlinkAccount: {
          ...state.unlinkAccount,
          unlinked: false,
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_UNLINK_ACCOUNT_FAILURE: {
      return {
        ...state,
        unlinkAccount: {
          ...state.unlinkAccount,
          unlinked: false,
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_PAGES_REQUEST: {
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: true,
          error: null,
          status: 'loading',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_PAGES_SUCCESS: {
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: false,
          list: action.payload.pages || [],
          error: null,
          status: 'success',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_PAGES_FAILURE: {
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: false,
          error: 'Failed to fetch ads pages',
          status: 'failure',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_REQUEST: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: true,
          error: null,
          status: 'loading',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_SUCCESS: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: false,
          data: action.payload,
          error: null,
          status: 'success',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_FAILURE: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: false,
          error: 'Failed to fetch drafts',
          status: 'failure',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_INSIGHTS_REQUEST: {
      return {
        ...state,
        insights: {
          ...state.insights,
          loading: true,
          status: 'loading',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_INSIGHTS_SUCCESS: {
      return {
        ...state,
        insights: {
          ...state.insights,
          loading: false,
          data: action.payload,
          status: 'success',
        },
      };
    }
    default:
      return state;
  }
};

export default adsHandlerReducer;
